<template>
  <div>
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {

  name: 'TextPlaceholder',
  props: {
    text: {
      type: String,
      default: '- - - - - - - - - -'
    }
  }
}
</script>
